import { useAIChat } from "../../context/AIChatContext";
import "./AIFloatButton.css";

const AIFloatButton = () => {
  const { openChat, chatOpen } = useAIChat();

  // Optional: hide button when chat is open
  if (chatOpen) return null;

  return (
    <button
      className="ai-float-btn"
      onClick={openChat}
      aria-label="Open AI Chat"
      title="Ask AI"
    >
      🤖
    </button>
  );
};

export default AIFloatButton;
